namespace AgerLMS {
    export enum EntityTypes {
        Bundle = 0,
        Course = 1,
        Lesson = 2,
        User = 3,
        Category = 4,
        Quiz = 5,
        Product = 6,
        Contact = 7,
        LiveBroadcast = 8,
        General = 99
    }
    Serenity.Decorators.registerEnumType(EntityTypes, 'AgerLMS.EntityTypes');
}
